jQuery(document).ready(function(){
    if( jQuery('body').hasClass('impersonation') )
    {

        if( jQuery('body').hasClass('my-orders') )
        {
            jQuery('#updateOrderModal').on('show.bs.modal', function(e) {
                updateOrderModal( e.relatedTarget.dataset.id ); 
            });

            jQuery('#replaceOrderModal').on('show.bs.modal', function(e) {
                updateOrderModal( e.relatedTarget.dataset.id, 'populateReplaceFields' ); 
            });

            jQuery("#cancelOrderModal").on('show.bs.modal', function(e) {
                jQuery("#cancelOrderModal input[name='order_id']").val( e.relatedTarget.dataset.id );
            });
        }



        /*
        jQuery(".support_ajax").on('submit', function(e){
            e.preventDefault();
            let actionUrl = jQuery(this).attr('action');

            jQuery("alert-container").empty();

            var postData = {};
            for(const field of jQuery(this).serializeArray())
            {
                postData[field.name] = field.value;
            }

            var alertContainer = jQuery("#alert-container");
            if( jQuery(this).find("#alert-container").length )
            {
                alertContainer = jQuery(this).find("#alert-container").first();
            }

            jQuery(this).find('[type="submit"]').first().attr('disabled', 'disabled');
            if (jQuery('#saveNotificationsChange')) {
                jQuery('#saveNotificationsChange').html(`Updating... <div class="spinner-border text-light ml-2" role="status">
                <span class="sr-only">Updating...</span>
                </div>`);
            }
            jQuery('.loading_wrapper').fadeIn();

            supportAjaxSubmit( postData );
        });
        */
    }
});

function updateReplacementOptions( element )
{
    switch( element.value )
    {
        case "replace":
            jQuery("#automaticReplacement").removeClass("d-none");
            jQuery("#manualLabelPrint").addClass("d-none");
        break;

        case "label":
            jQuery("#manualLabelPrint").removeClass("d-none");
            jQuery("#automaticReplacement").addClass("d-none");
        break;

        default:
            jQuery("#automaticReplacement, #manualLabelPrint").addClass("d-none");
    }
}

function updateOrderModal( orderId, successFunction = 'populateUpdateFields' )
{
    let postData = {
        'action': 'get_order_data',
        'payment_id': orderId
    };
    
    supportAjaxSubmit( postData, successFunction );
}


function supportAjaxSubmit( postData, successFunction = '' )
{
    const ajaxUrl = '/wp-admin/admin-ajax.php';
    
    jQuery.ajax({
        url: ajaxUrl,
        type: "POST",
        beforeSend: function(xhr){
            xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));
        },
        data: postData,
        dataType: 'json',
        success: function(response) {

            if(successFunction != '')
            {
                var fn = window[successFunction];
                fn.apply(window, [response.data]);
            }

        },
        error: function(response) {
            console.error('Error: ', response);
        },
    });
}

function populateUpdateFields( params )
{
    jQuery("#orderPaymentIdEdit").val( params.payment_id );

    jQuery("#orderNameEdit").val( params.shipping_name );
    jQuery("#orderStreetEdit").val( params.address_1 );
    jQuery("#orderStreet2Edit").val( params.address_2 );
    jQuery("#orderCityEdit").val( params.city );
    jQuery("#orderZipEdit").val( params.zip );
    jQuery("#orderStateEdit").val( params.state );
    jQuery("#orderCountryEdit").val( params.country );

    jQuery("#orderFirstCountryEdit").val( params.first_country );
    jQuery("#orderSizeEdit").val( params.plan );
}

function populateReplaceFields( params )
{
    jQuery("#replacePaymentIdEdit").val( params.payment_id );

    jQuery("#replaceNameEdit").val( params.shipping_name );
    jQuery("#replaceStreetEdit").val( params.address_1 );
    jQuery("#replaceStreet2Edit").val( params.address_2 );
    jQuery("#replaceCityEdit").val( params.city );
    jQuery("#replaceZipEdit").val( params.zip );
    jQuery("#replaceStateEdit").val( params.state );
    jQuery("#replaceCountryEdit").val( params.country );

    jQuery("#replaceFirstCountryEdit").val( params.first_country );
    jQuery("#replacePlanEdit").val( params.plan );

}

function toggleReplacementReasonText( element )
{
    console.log(element.selectedOptions[0].innerText);
    if( element.value == 0 )
    {
        jQuery("#replaceReasonTextEdit").parent().removeClass('d-none');
        jQuery("#replaceReasonTextEdit").val("");
    }
    else
    {
        jQuery("#replaceReasonTextEdit").parent().addClass('d-none');
        jQuery("#replaceReasonTextEdit").val(element.selectedOptions[0].innerText);
    }
}